import React from 'react'
import clsx from 'clsx'
import Link from '@/atoms/Link/Link'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} from 'react-share'

// assets
import { ReactComponent as SolsticeLogo } from 'public/assets/solstice/images/Solstice.svg'
import FacebookWhiteIcon from 'public/assets/icons/social/facebook-white.svg'
import TwitterWhiteIcon from 'public/assets/icons/social/twitter-white.svg'
import LinkedInWhiteIcon from 'public/assets/icons/social/linkedin-white.svg'

interface Props {
  className?: string
}

const SolsticeFooter: React.FC<Props> = ({ className }) => {
  const location = 'www.peppercontent.io/solstice'
  const title =
    'Check out Creative Solstice - the ultimate global summit for creative intelligence. I am excited to attend the insightful sessions and expand my network among thought leaders, marketers, and creators. You can too! Register now: '
  return (
    <div
      className={clsx(
        className,
        'flex flex-col gap-2 justify-between items-center lg:flex-row  |  pt-5 pb-8'
      )}
    >
      <div className="text-paragraph-3  |  space-x-12">
        <Link href="https://www.airmeet.com/e/1c4fb4c0-29f7-11ed-bb22-3d2b6b56f545">
          Join Now
        </Link>
        <Link href="/solstice/#speakers">Speakers</Link>
        <Link href="/solstice/#agenda">Schedule</Link>
      </div>

      <Link
        href="#solstice-hero"
        className="lg:absolute | lg:transform lg:-translate-x-1/2 | lg:left-1/2"
      >
        <SolsticeLogo className="md:w-[150px] | md:h-[50px]" />
      </Link>

      <div className="flex items-center">
        <span className="text-paragraph-3 | mr-4">Share this event</span>

        <div className={clsx('flex gap-2 items-center', className)}>
          <FacebookShareButton
            quote={title}
            hashtag="#peppercontent"
            url={location}
          >
            <img
              className="h-6 w-6"
              title="Share on Facebook"
              src={FacebookWhiteIcon}
              alt="Share on Facebook"
            />
          </FacebookShareButton>
          <TwitterShareButton title={`${title}`} url={location}>
            <img
              className="h-6 w-6"
              title="Share on Twitter"
              src={TwitterWhiteIcon}
              alt="Share on Twitter"
            />
          </TwitterShareButton>
          <LinkedinShareButton url={location} title={`${title}`}>
            <img
              className="h-6 w-6"
              title="Share on LinkedIn"
              src={LinkedInWhiteIcon}
              alt="Share on Linkedin"
            />
          </LinkedinShareButton>
        </div>
      </div>
    </div>
  )
}

export default SolsticeFooter
